<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeGame"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeGame" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>

    <div class="w-100 d-flex justify-center">
      <div class="table-show" style="width: 100%; padding: 0 5% 64px 5%">
        <WheelOfFortune
          :listItem="gameSetting.listItem"
          :textSpinBtn="gameSetting.textAction"
          :colorSpinBtn="gameSetting.colorTextAction"
          :bgColorSpinBtn="gameSetting.bgColorTextAction"
          :showSpinBtn="!gameSetting.useBtnAction"
          :actionSpinWheel="gameSetting.wheelOfFortune.actionSpinWheel"
          :colorFrame="gameSetting.wheelOfFortune.colorFrame"
          :colorPointer="gameSetting.wheelOfFortune.colorPointer"
          :colorMiddle="gameSetting.wheelOfFortune.colorMiddle"
          :funcGetResultGame="getResultGame"
          @onEnd="handleEndWheel"
        />
        <v-btn
          v-if="gameSetting.useBtnAction && gameSetting.listItem.length > 0"
          class="w-100"
          style="text-transform: unset !important"
          :style="{
            color: gameSetting.colorTextAction,
            backgroundColor: gameSetting.bgColorTextAction,
          }"
          @click="handleStartGame"
          >{{ gameSetting.textAction }}</v-btn
        >
        <v-btn
          v-if="gameSetting.listItem.length == 0"
          class="w-100 mt-4"
          style="text-transform: unset !important"
          :style="{
            color: gameSetting.colorTextAction || '#000000',
            backgroundColor: gameSetting.bgColorTextAction || '#FFFFFF',
          }"
          @click="handleStartGame"
          >{{ $t("microsite.textBack") }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Model } from "survey-core";
import { mapState } from "vuex";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import WheelOfFortune from "@/components/game/wheel-of-fortune.vue";
import { addClassQlEditorToSDDisplay, customThemeSurveyJS } from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

export default {
  name: "MicrositeGame",
  inject: ["isAppLoading"],
  components: {
    Survey,
    WheelOfFortune,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: null,
    survey: null,
    surveyJson: null,
    themeJson: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    gameSetting: {
      wheelOfFortune: {},
      listItem: [],
    },

    transactionId: null,
    errorMsg: "",

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    this.isAppLoading(true);
    await this.getCampaign();
    await this.getHistory();
    await this.getSurveyAndTheme();
    this.isAppLoading(false);

    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    async getHistory() {
      try {
        const response = await MicrositeAxios.get(
          `checkPhoneNumber/${this.campaign.id}?phone=${encodeURIComponent(
            this.user.phone
          )}`
        );
        const userExists = response?.data?.data?.users;
        if (userExists) {
          const countTransaction = userExists?.campaignTransaction?.filter(
            (x) => x.item_json
          )?.length;
          let game_limit = userExists.game_limit;
          if (countTransaction >= game_limit) {
            this.$swal
              .fire({
                icon: "warning",
                text: this.$t("microsite.errActivityAlreadyJoined"),
                showCancelButton: false,
                confirmButtonText: this.$t("microsite.textBack"),
                allowOutsideClick: false,
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.$router.push({ name: "microsite-menu" });
                }
              });
          }
        } else {
          this.$swal
            .fire({
              icon: "error",
              title: this.$t("microsite.dataNotFound"),
              showConfirmButton: true,
            })
            .then(() => {
              this.$router.push({ name: "microsite-login" });
            });
        }
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            title: this.$t("microsite.errGeneral"),
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.push({ name: "microsite-login" });
          });
        console.log(error);
      }
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;

        if (this.campaign.game_json) {
          this.gameSetting = JSON.parse(this.campaign.game_json);
        }
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.game) {
        this.surveyJson = surveyJson.game;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).game;
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    async getReward() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;

        if (this.campaign.game_json) {
          this.gameSetting = JSON.parse(this.campaign.game_json);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleEndWheel() {
      this.isAppLoading(true);
      if (this.transactionId) {
        this.$router.push({
          name: "microsite-thankyou-game",
          query: {
            transaction_id: this.transactionId,
          },
        });
      } else {
        let textError = this.errorMsg || this.$t("microsite.errActivity");
        let textBtn = this.$t("microsite.textBack");
        if (textError == "ขออภัยค่ะ ของรางวัลหมดแล้ว") {
          textBtn = this.$t("microsite.textRefresh");
        }
        this.$swal
          .fire({
            icon: "warning",
            text: textError,
            showCancelButton: false,
            confirmButtonText: textBtn,
            allowOutsideClick: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              if (this.errorMsg == "error_not_enough") {
                location.reload();
              } else {
                this.$router.push({ name: "microsite-menu" });
              }
            }
          });
      }
      this.isAppLoading(false);
    },
    async getResultGame() {
      let item_id = null;
      try {
        const response = await MicrositeAxios.post(
          `getAndUpdateTransactionResultGame/${this.campaign.id}`,
          {
            phone: this.user.phone,
          }
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          item_id = data?.result?.item_id;
          this.transactionId = data?.transaction?.id;
        } else {
          this.errorMsg = dataResponse?.message;
        }
      } catch (err) {
        console.log(err);
      }
      return item_id;
    },
    handleStartGame() {
      if (this.gameSetting.listItem?.length == 0) {
        this.$router.push({ name: "microsite-menu" });
        return;
      }
      this.gameSetting.wheelOfFortune.actionSpinWheel = true;
      setTimeout(() => {
        this.gameSetting.wheelOfFortune.actionSpinWheel = false;
      }, 1000);
    },
  },
};
</script>

<style scoped>
/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
/* add-on */
::v-deep .sd-body {
  padding-bottom: 0px !important;
}
::v-deep .sd-navigation__complete-btn {
  display: none;
}
::v-deep .sd-action-bar {
  display: none;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
